(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    class CustomAccordion extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-accordion-trigger]');
      this._handleClick = () => this.toggle();
      this.trigger.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      this.trigger.removeEventListener('click', this._handleClick);
    }

    closeSiblings() {
      const parent = this.parentElement;
      if(!parent) return;
      const siblings = parent.querySelectorAll(':scope > custom-accordion[open]');
      siblings.forEach((a) => a.close());
    }

    toggle() {
      this.hasAttribute('open') ? this.close() : this.open();
    }

    open() {
      if (this.hasAttribute('data-close-siblings')) {
        this.closeSiblings();
      }
      this.setAttribute('open', '');
    }

    close() {
      this.removeAttribute('open');
      this.querySelectorAll(':scope > custom-accordion[open]').forEach((a) => a.close());
    }
  }

  if (!customElements.get('custom-accordion')) {
    customElements.define('custom-accordion', CustomAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
